/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Heading_VoidInputs */



/**
* | output |
* | --- |
* | "Shuffled into the void" |
*
* @param {Error_Heading_VoidInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const error_heading_void = /** @type {((inputs?: Error_Heading_VoidInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Heading_VoidInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ins Nichts gemischt")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mélangée dans le néant")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("被洗进了虚空")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("被洗進虛空裡了")
	if (locale === "ko") return /** @type {LocalizedString} */ ("공허 속에 섞여 버렸습니다")
	return /** @type {LocalizedString} */ ("Shuffled into the void")
});